<template>
  <div class="container">
    <div class="bt">
      <router-link :to="{path:'/'}"><div class="dh_sy"></div></router-link>
      <div class="left_cjt"></div>
      <div class="right_cjt"></div>
      <div class="dh_fy" @click="clickReturn"></div>
    </div>
    <div class="small_bt">
      <div class="music">
        <span></span> <span></span> <span></span><span></span>
      </div>
      <div class="s_yqgk">园区概况</div>
    </div>
    <div class="content">
      <div class="content_left">
        <div class="c_l_top">
          <router-link :to="{path:'/jiagong'}"><div class="c_l_t_top">园区简介<img :src="url+'/img/jiantou2.gif'" /></div></router-link>
          <div class="c_l_t_middle">
            <img :src="url+'/img/kshyqjk/yqt.png'" />
          </div>
          <div class="c_l_t_down">
            <txtScroll>
              <div v-for="item in textList" :key="item.id" class="scroll_item">
                {{ item.title }}
              </div>
            </txtScroll>
          </div>
        </div>
        <div class="c_l_down">
          <router-link :to="{path:'/jiagong'}"><div class="subTit">园区情况<img :src="url+'/img/jiantou2.gif'" /><div class="line"><div class="line1"></div></div></div></router-link>
          <div class="c_l_down_content">
            <div class="c_l_d_nr">
            <span class="star2">管理人员</span>
            <span class="star"></span
            ><!-- 第一颗星 -->
            <span class="star"></span
            ><!-- 第二颗星 -->
            <span class="star"></span
            ><!-- 第三颗星 -->
            <span class="star"></span
            ><!-- 第四颗星 -->
            <span class="star1"></span
            ><!-- 第五颗星 -->
            <span class="star1"></span
            ><!-- 第六颗星 -->
            <span class="star3">正常</span>
          </div>
          <div class="c_l_d_nr">
            <span class="star2">园区安全</span> <span class="star"></span
            ><!-- 第一颗星 -->
            <span class="star"></span
            ><!-- 第二颗星 -->
            <span class="star"></span
            ><!-- 第三颗星 -->
            <span class="star"></span
            ><!-- 第四颗星 -->
            <span class="star1"></span
            ><!-- 第五颗星 -->
            <span class="star1"></span
            ><!-- 第六颗星 -->
            <span class="star3">正常</span>
          </div>
          <div class="c_l_d_nr">
            <span class="star2">区域管理</span> <span class="star"></span
            ><!-- 第一颗星 -->
            <span class="star"></span
            ><!-- 第二颗星 -->
            <span class="star"></span
            ><!-- 第三颗星 -->
            <span class="star1"></span
            ><!-- 第四颗星 -->
            <span class="star1"></span
            ><!-- 第五颗星 -->
            <span class="star1"></span
            ><!-- 第六颗星 -->
            <span class="star3">正常</span>
          </div>
          <div class="c_l_d_nr">
            <span class="star2">园区出入</span> <span class="star"></span
            ><!-- 第一颗星 -->
            <span class="star"></span
            ><!-- 第二颗星 -->
            <span class="star"></span
            ><!-- 第三颗星 -->
            <span class="star1"></span
            ><!-- 第四颗星 -->
            <span class="star1"></span
            ><!-- 第五颗星 -->
            <span class="star1"></span
            ><!-- 第六颗星 -->
            <span class="star3">正常</span>
          </div>
          </div>
          
        </div>
      </div>
      <div class="content_middle">
        <div class="c_m_top">{{sxtList[videoIndex].options.name}}</div>
        <div class="c_m_middle">
          <div class="c_m_middle_sxt">
            <vue3VideoPlay
              width="100%"
              height="100%"
              :src="sxtList[videoIndex].options.src"
              :type="sxtList[videoIndex].options.type"
              :autoPlay="true"
              :muted="true"
              :control="false"
              :controlBtns="false"
            />
          </div>
          <div class="sxt_zs1"></div>
          <div class="sxt_zs2"></div>
          <div class="sxt_zs3"></div>
          <div class="sxt_zs4"></div>
        </div>
        <div class="c_m_down">
          <div
            class="c_m_d_sxt_l"
            v-for="(item, index) in sxtList"
            :key="index"
            @click="switchVideo(index)"
          >
            <div class="c_m_d_sxt_list"><img :src="item.poster" /></div>

            <div class="c_m_d_sxt_list_name">{{ item.options.name }}</div>
          </div>
        </div>
        <div class="c_m_down_jdt"><div class="c_m_down_jdt_line"></div></div>
      </div>
      <div class="content_right">
        <div class="c_r_top">
            <div class="subTit">安全问题<div class="line"><div class="line1"></div></div></div>
            <div class="c_r_Content"><RightRadar /></div>
        </div>
        <div class="c_r_middle">
           <router-link :to="{path:'/chejian'}"><div class="subTit">设备时长<img :src="url+'/img/jiantou2.gif'" /><div class="line"><div class="line1"></div></div></div></router-link>
          <div class="c_r_Content"><RightBar /></div>
        </div>
        <div class="c_r_down">
          <div class="subTit">设备状态<div class="line"><div class="line1"></div></div></div>
          <div class="c_r_Content"><RightBar1 /></div>
        </div>
      </div>
    </div>
  </div>
  <footer1 />
</template>

<script>
import axios from "axios";
import { useRouter } from "vue-router";
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue";
import RightRadar from "../components/kshyqjk/RightRadar.vue";
import RightBar from "../components/kshyqjk/RightBar.vue";
import RightBar1 from "../components/kshyqjk/RightBar1.vue";
import footer1 from "../components/footer.vue";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      options: {
        src: "https://open.ys7.com/v3/openlive/AY8102738_1_1.m3u8?expire=1740449127&id=683978271701962752&t=32fd16255e936bfaa81cc45ee5e2cf2b69608fa7cbd61ceadc555f402a811134&ev=100", //视频源
        type: "m3u8", //视频类型
      },
      videoIndex:0,
      config: {
        colors: ["#03947B", "#03947B"],
        value: 66,
        borderWidth: 1,
        borderRadius: 3,
        borderGap: 1,
      },
      sxtList: [
        {
          options: {
            id: 1,
            src: "https://open.ys7.com/v3/openlive/AZ8538196_1_2.m3u8?expire=1740966277&id=686147354503417856&t=123d4037896f141542244fcbc3f54a2b39eeec75577f00bd9f9b7069b63b8027&ev=100 ", //视频源
            type: "m3u8", //视频类型
            name: "生产车间1号",
          },
          poster:require('@/assets/img/kshyqjk/img1.jpg')
        },
        {
          options: {
            id: 3,
            src: "https://open.ys7.com/v3/openlive/AZ8538196_2_2.m3u8?expire=1740966371&id=686147749082574848&t=d36549a2a4831a0320f7ec37c33956d6c30bb36f1b48e7da8d84b87a5552c640&ev=100", //视频源
            type: "m3u8", //视频类型
            name: "生产车间3号",
          },
          poster:require('@/assets/img/kshyqjk/img3.jpg')
        },
        {
          options: {
            id: 2,
            src: "https://open.ys7.com/v3/openlive/AZ8538420_1_2.m3u8?expire=1740966347&id=686147650010435584&t=fd88bc4a5f58ca8c2f26a60fb0f1064191d9b7b07252fc8f07b415ae9ffafe58&ev=100 ", //视频源
            type: "m3u8", //视频类型
            name: "生产车间3号",
          },
           poster:require('@/assets/img/kshyqjk/img2.jpg')
        },
        {
          options: {
            id: 4,
            src: "https://open.ys7.com/v3/openlive/AZ8538420_2_2.m3u8?expire=1740966420&id=686147955109896192&t=b761ebc9dfe983909556402befe83a5f6a1e14c376196f76097881de0f72f880&ev=100 ", //视频源
            type: "m3u8", //视频类型
            name: "生产车间4号",
          },
           poster:require('@/assets/img/kshyqjk/img4.jpg')
        },
        {
          options: {
            id: 3,
            src: "https://open.ys7.com/v3/openlive/AZ8538196_2_2.m3u8?expire=1740966371&id=686147749082574848&t=d36549a2a4831a0320f7ec37c33956d6c30bb36f1b48e7da8d84b87a5552c640&ev=100", //视频源
            type: "m3u8", //视频类型
            name: "生产车间5号",
          },
          poster:require('@/assets/img/kshyqjk/img3.jpg')
        },
        {
          options: {
            id: 2,
            src: "https://open.ys7.com/v3/openlive/AZ8538420_1_2.m3u8?expire=1740966347&id=686147650010435584&t=fd88bc4a5f58ca8c2f26a60fb0f1064191d9b7b07252fc8f07b415ae9ffafe58&ev=100 ", //视频源
            type: "m3u8", //视频类型
            name: "生产车间6号",
          },
           poster:require('@/assets/img/kshyqjk/img2.jpg')
        },
      ],
      textList: [
        {
          title:
            "高标准农田是指在一定时期内，按照国家相关标准和规划要求，在适宜农业生产区域建设的综合生产能力和生态环境良好的永久基本农田。它具有以下几个显著特征：",
        },
        {
          title:
            "高产稳产：通过土地平整、土壤改良、灌溉排水设施完善等措施，提高农田产出能力，确保粮食和其他农产品稳定高产。",
        },
        {
          title:
            "集中连片：农田布局合理，田块规整，便于规模化、机械化作业和统一管理，降低生产成本，提高劳动效率。",
        },
        {
          title:
            "设施配套：配备完善的水利、电力、道路等基础设施，包括但不限于节水灌溉系统、排涝防洪设施、田间道路网等，以满足现代农业生产和经营需要。",
        },
        {
          title:
            "生态友好：注重农田生态保护与修复，实施耕地质量保护提升工程，强化农业面源污染治理，实现农田可持续利用。",
        },
        {
          title:
            "信息化程度高：推广现代信息技术应用，如遥感监测、物联网技术、精准农业等，提升农田管理智能化水平。",
        },
        {
          title:
            "信息化程度高：推广现代信息技术应用，如遥感监测、物联网技术、精准农业等，提升农田管理智能化水平。",
        },
      ],
    });
    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function switchVideo(index) {
      // console.log(index);
      state.videoIndex = index
      // if (state.sxtList[index] && state.sxtList[index].options) {
      //   state.videoIndex = index
      // } else {
      //   console.error("Invalid video source for index:", index);
      // }
    }
    onMounted(() => {
      // clearInterval(state.timer.value);
      // state.value = setInterval(() => {
      //   state.currentTime = proxy.$utils.getCurrentTime();
      // }, 1000);
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
    return {
      ...toRefs(state),
      clickReturn,
      switchVideo
    };
  },
  components: {
    txtScroll,
    RightRadar,
    RightBar,
    RightBar1,
    footer1
  },
};
</script>

<style lang="less" scoped>
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
.container {
  width: 100%;
  min-height: 100vh;
  background-color: #000;

  color: #fff;
  position: relative;
  .bt {
    width: 100%;
    height: 95px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/bt.png") no-repeat top center;
    background-size: 100% 100%;
    position: relative;
    .dh_sy {
      width: 68px;
      height: 23px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/sy.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: 2%;
      top: 35%;
      cursor: pointer;
    }
    .dh_sy:hover {
      cursor: pointer;
    }
    .left_cjt {
      width: 130px;
      height: 25px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/cjt.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      left: 8%;
      top: 35%;
      animation: titleGuang1 2s linear infinite;
    }
    .right_cjt {
      width: 130px;
      height: 25px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/cjt.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      right: 8%;
      top: 35%;
      transform: scaleX(-1);
      animation: titleGuang2 2s linear infinite;
    }
    .dh_fy {
      width: 68px;
      height: 23px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/fh.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      right: 2%;
      top: 35%;
      cursor: pointer;
    }
    .dh_fy:hover {
      cursor: pointer;
    }
  }

  .small_bt {
    width: 100%;
    height: 42px;
    position: relative;
    display: flex;
    flex-direction: row;
    background-color: #00140e;

    .s_yqgk {
      width: 100px;
      height: 100%;
      line-height: 42px;
      font-size: 20px;
      color: #C7C8CC;
      margin-left: 2%;
    }
  }
  .content {
    width: 98%;
    height: 84%;
    // border: 1px solid #fff;
    position: absolute;
    left: 1%;
    top: 140px;
    display: flex;
    flex-direction: row;
    .content_left {
      width: 360px;
      height: 100%;
      margin-right: 5px;
      // border: 1px solid #23ebda;
      display: flex;
      flex-direction: column;
      .c_l_top {
        width: 100%;
        // height: 550px;
        // border: 1px solid #23ebda;
        flex: 1;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/z1.png") no-repeat top center;
        background-size: 100% 100%;
        margin-bottom: 1%;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        .c_l_t_top {
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          color: #C7C8CC;
          text-align: left;
          margin-top: 18px;
          margin-bottom: 10px;
          text-indent: 2em;
          display: flex;
          justify-content: space-between;
          img{
            height: 14px;
            margin-right: 20px;
          }
        }
        .c_l_t_middle {
          width: 334px;
          height: 188px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/jjbj.png") no-repeat top center;
          background-size: 100% 100%;
          margin-left: 13px;
          img {
            width: 96%;
            height: 96%;
            margin: 2% 2%;
          }
        }
        .c_l_t_down {
          width: 100%;
          // height: 200px; 
          flex: 1;
          margin-top: 30px;
          padding: 0 0 20px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .scroll_item {
            width: 100%;
            // height: 40px;

            // margin-top: 20%;
            color: #fff;
            text-align: left;
            line-height: 20px;
            font-size: 14px;
          }
        }
      }
      .c_l_down {
        width: 100%;
        height: 300px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/z2.png") no-repeat top center;
        background-size: 100% 100%;
        margin-top: 2%;
        display: flex;
        flex-direction: column;
        .c_l_down_content{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .c_l_d_bt {
          width: 100%;
          height: 25px;
          line-height: 25px;
          font-size: 14px;
          color: #fff;
          text-align: left;
          margin-top: 10px;
          text-indent: 2em;
        }
        .c_l_d_nr {
          width: 100%;
          height: 25px;
          // margin-bottom: 10px;
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          .star {
            width: 20px;
            height: 20px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/lxx.png") no-repeat top
              center;
            background-size: 100% 100%;
            font-size: 14px;
            color: #c7c8cc;
            margin: 0 4px;
          }

          .star1 {
            width: 20px;
            height: 20px;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/hxx.png") no-repeat top
              center;
            font-size: 14px;
            color: #197c8a;
            background-size: 100% 100%;
            margin: 0 4px;
          }
          .star2 {
            width: 85px;
            height: 25px;
            font-size: 14px;
            line-height: 25px;
            color: #c7c8cc;
            margin: 0 3px;
          }
          .star3 {
            width: 70px;
            height: 25px;
            line-height: 25px;
            font-size: 14px;
            color: #197c8a;

            margin: 0 3px;
          }
        }
      }
    }
    .content_middle {
      flex: 1;
      width: 100%;
      // border: 1px solid #23ebda;
      margin: 0 3px;
      display: flex;
      flex-direction: column;
      .c_m_top {
        width: 100%;
        height: 35px;
        margin-top: 10px;
        font-size: 14px;
        line-height: 35px;
        color: #fff;
        text-align: left;
        text-indent: 2em;
      }
      .c_m_middle {
        flex: 1;
        margin: 1% 0;
        position: relative;
        .c_m_middle_sxt {
          width: 75%;
          height: 100%;
          margin-left: 12.5%;
        }
        .sxt_zs1 {
          width: 25px;
          height: 90px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/djt.png") no-repeat top center;
          background-size: 100% 100%;
          position: absolute;
          top: 10%;
          left: 5%;
        }
        .sxt_zs2 {
          width: 25px;
          height: 90px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/djt.png") no-repeat top center;
          background-size: 100% 100%;
          position: absolute;
          top: 60%;
          left: 5%;
        }
        .sxt_zs3 {
          width: 25px;
          height: 90px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/djt.png") no-repeat top center;
          background-size: 100% 100%;
          position: absolute;
          top: 10%;
          right: 5%;
        }
        .sxt_zs4 {
          width: 25px;
          height: 90px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/djt.png") no-repeat top center;
          background-size: 100% 100%;
          position: absolute;
          top: 60%;
          right: 5%;
        }
      }
      .c_m_down {
        width: 100%;
        height: 200px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/sxt.png") no-repeat top center;
        background-size: 100% 100%;
        margin-bottom: 5px;
        display: flex;
        flex-direction: row;
        .c_m_d_sxt_l {
          flex: 1;
          height: 165px;
          margin: 0 5px;
          margin-top: 30px;
          // border: #197c8a 1px solid;
          display: flex;
          flex-direction: column;
          .c_m_d_sxt_list {
            width: 100%;
            height: 135px;
            // background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/yqt.png") no-repeat top center;
            // background-size: 100% 100%;
            cursor: pointer;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .c_m_d_sxt_list_name {
            width: 100%;
            height: 30px;
            font-size: 14px;
            line-height: 30px;
            color: #d2d2d2;
            cursor: pointer;
          }
          .c_m_d_sxt_list_name:hover {
            cursor: pointer;
          }
        }
      }
      .c_m_down_jdt {
        margin-top: 1%;
        width: 100%;
        height: 4px;
        background: #484848;
        border-radius: 2px;
        position: relative;
        overflow: hidden;
        .c_m_down_jdt_line{
          position: absolute;
          top: 0;
          width: 20%;
          height: 4px;
          background-image: linear-gradient(to right, rgba(15,179,142,0) ,rgba(15,179,142,1));
          animation: line1 3s infinite linear;
          z-index: 999;
        }
      }
    }
    .content_right {
      width: 360px;
      height: 100%;
      margin-left: 5px;
      display: flex;
      flex-direction: column;
      // border: 1px solid #23ebda;
      .c_r_Content{
          width: 100%;
          flex: 1;
        }
      .c_r_top {
        width: 100%;
        margin-top: 10px;
        flex: 1;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/y1.png") no-repeat top center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
      }
      .c_r_middle {
        width: 100%;
        flex: 1;
        margin: 3% 0;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/y2.png") no-repeat top center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
      }
      .c_r_down {
        width: 100%;
        height: 200px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/kshyqjk/y3.png") no-repeat top center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.subTit{
  font-size: 16px;
  color: #C7C8CC;
  text-align: left;
  line-height: 25px;
  margin-top: 10px;
  margin-left: 15px;
  position: relative;
  .line{
    display: block;
    width: 166px;
    height: 2px;
    background: linear-gradient(to right, rgba(255,255,255,.8) , rgba(255,255,255,0));
    margin-top: 5px;
    position: relative;
    .line1{
      position: absolute;
      bottom: 0;
      display: block;
      width: 100px;
      height: 2px;
      background: linear-gradient(to right,rgba(255,255,255,0), rgba(255,255,255,.5) , rgba(255,255,255,0));
      animation: line1 1.5s infinite linear;
    }
  }
  img{
    position: absolute;
    right: 16px;
    top: -2px;
    height: 14px;
    margin-top: 10px;
  }
  
}
 @keyframes line1 {
      0% {left: 0%;}
      100% {left: 100%;}
    }
.music {
  height: 15px;
  display: flex;
  position: absolute;
  right: 98%;
  top: 15px;
}

.music span {
  width: 3px;
  border-radius: 18px;
  margin-right: 4px;
}

.music span:nth-child(1) {
  /* 时间递增，参差不齐的效果 */
  animation: bar1 2s 0.2s infinite linear;
}

.music span:nth-child(2) {
  animation: bar2 2s 0.4s infinite linear;
}

.music span:nth-child(3) {
  animation: bar3 2s 0.6s infinite linear;
}

.music span:nth-child(4) {
  animation: bar4 2s 0.8s infinite linear;
}

.music span:nth-child(5) {
  animation: bar5 2s 1s infinite linear;
}

.music span:nth-child(6) {
  animation: bar6 2s 1.2s infinite linear;
}

.music span:nth-child(7) {
  animation: bar7 2s 1.4s infinite linear;
}

.music span:nth-child(8) {
  animation: bar8 2s 1.6s infinite linear;
}

.music span:nth-child(9) {
  animation: bar9 2s 1.8s infinite linear;
}

@keyframes bar1 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar2 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar3 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar4 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar5 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar6 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar7 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar8 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes bar9 {
  0% {
    background: #fff;
    margin-top: 25%;
    height: 10%;
  }

  50% {
    background: #fff;
    height: 100%;
    margin-top: 0%;
  }

  100% {
    background: #fff;
    height: 10%;
    margin-top: 25%;
  }
}

@keyframes titleGuang1 {
  0% {
    left: 8%;
  }
  50% {
    left: 9%;
  }
  100% {
    left: 8%;
  }
}
@keyframes titleGuang2 {
  0% {
    right: 8%;
  }
  50% {
    right: 9%;
  }
  100% {
    right: 8%;
  }
}
</style>
